module.exports = __webpack_public_path__ + "assets/icons/ic_arrow_back_24px.svg";